import {
	DetectionResultEnum,
	DetectionStatusEnum,
	FileTypeEnum,
	TextDetectionResultEnum,
} from "@/types/common";

export function formatStatusOptions(formatMessageSelf, statusOptions) {
	return statusOptions.map((item) => {
		return {
			...item,
			label:
				item.value === 1
					? formatMessageSelf("app.task.status.testing")
					: item.value === 2
					? formatMessageSelf("app.task.status.completed")
					: formatMessageSelf("app.task.status.failed"),
		};
	});
}

export function formatMenuItem(formatMessageSelf, menuItem) {
	return menuItem.map((item) => {
		const newItem = item;
		switch (item.key) {
			case "content-check":
				newItem.title = formatMessageSelf("app.menu.contentcheck");
				break;
			case "content-check-image-class":
				newItem.title = formatMessageSelf("app.menu.contentcheck.image");
				break;
			case "content-check-video-class":
				newItem.title = formatMessageSelf("app.menu.contentcheck.video");
				break;
			case "content-check-deepfake":
				newItem.title = formatMessageSelf("app.menu.contentcheck.deepfake");
				break;
			case "content-check-diffusion":
				newItem.title = formatMessageSelf("app.menu.contentcheck.diffusion");
				break;
			case "content-check-diffusion-full-frame":
				newItem.title = formatMessageSelf(
					"app.menu.contentcheck.diffusion_full_frame"
				);
				break;
			case "content-check-llm":
				newItem.title = formatMessageSelf("app.menu.contentcheck.llm");
				break;
			case "check-result":
				newItem.title = formatMessageSelf("app.menu.checkresult");
				break;
			case "user-management":
				newItem.title = formatMessageSelf("app.menu.usermanagement");
				break;
			case "config":
				newItem.title = formatMessageSelf("app.menu.config");
				break;
			case "config-person":
				newItem.title = formatMessageSelf("app.menu.config.person");
				break;
		}
		if (item.children) {
			newItem.children = formatMenuItem(formatMessageSelf, item.children);
		}
		return newItem;
	});
}

export function formatFileTypeConfig(formatMessageSelf, fileTypeConfig) {
	const newFileTypeConfig = { ...fileTypeConfig };
	for (const key in fileTypeConfig) {
		switch (key) {
			case String(FileTypeEnum.IMAGE):
				newFileTypeConfig[key].text = formatMessageSelf("app.common.media.img");
				newFileTypeConfig[key].label = formatMessageSelf(
					"app.common.media.img"
				);
				break;
			case String(FileTypeEnum.VIDEO):
				newFileTypeConfig[key].text = formatMessageSelf(
					"app.common.media.video"
				);
				newFileTypeConfig[key].label = formatMessageSelf(
					"app.common.media.video"
				);
				break;
			case String(FileTypeEnum.AUDIO):
				newFileTypeConfig[key].text = formatMessageSelf(
					"app.common.media.audio"
				);
				newFileTypeConfig[key].label = formatMessageSelf(
					"app.common.media.audio"
				);
				break;
			case String(FileTypeEnum.TEXT):
				newFileTypeConfig[key].text = formatMessageSelf(
					"app.common.media.text"
				);
				newFileTypeConfig[key].label = formatMessageSelf(
					"app.common.media.text"
				);
				break;
			default:
		}
	}
	return newFileTypeConfig;
}

// 检测状态
export function formatDetectionStatusConfig(
	formatMessageSelf,
	detectionStatusConfig
) {
	const newDetectionStatusConfig = { ...detectionStatusConfig };
	for (const key in detectionStatusConfig) {
		switch (key) {
			case String(DetectionStatusEnum.DETECTING):
				newDetectionStatusConfig[key].text = formatMessageSelf(
					"app.task.status.testing"
				);
				break;
			case String(DetectionStatusEnum.SUCCESS):
				newDetectionStatusConfig[key].text = formatMessageSelf(
					"app.task.status.completed"
				);
				break;
			case String(DetectionStatusEnum.FAIL):
				newDetectionStatusConfig[key].text = formatMessageSelf(
					"app.task.status.failed"
				);
				break;
			default:
		}
	}
	return newDetectionStatusConfig;
}

// 文件类型 [{label: value: ]
export function formatFileTypeOptions(formatMessageSelf, fileTypeOptions) {
	return fileTypeOptions.map((item) => {
		return {
			...item,
			label:
				item.value === 0
					? formatMessageSelf("app.common.media.img")
					: item.value === 1
					? formatMessageSelf("app.common.media.video")
					: item.value === 2
					? formatMessageSelf("app.common.media.audio")
					: formatMessageSelf("app.common.media.text"),
		};
	});
}
